<template>
  <div
    class="list-header"
    id="toplist"
    :class="{ act: selectedCount, a1: showA1 }"
  >
    <div
      class="item-header"
      :class="[
        { 'item-check-header-selected': selectedCount },
        { 'item-check-header-no-selected': !selectedCount },
      ]"
    >
      <div class="checkbox" @click="toggleSelectAll">
        <i class="ti-check"></i>
      </div>
      <div
        class="item-selected-number"
        style="display: block"
        v-if="selectedCount"
      >
        已选择{{ selectedCount }}项
      </div>
    </div>

    <div
      v-for="header in headers"
      :key="header.id"
      class="item-header"
      :class="'item-' + header.class + '-header'"
      v-show="
        !selectedCount &&
        (isList || header.id === 1) &&
        header.display.indexOf(tab) > -1
      "
      @click="sortByHeader(header.id)"
    >
      <div class="file-icon" v-show="header.id === 1">
        <i class="fa fa-file-o"></i>
      </div>
      <p>{{ header.title }}</p>
      <span class="sort" :class="header.sort" v-show="header.showSort"></span>
    </div>

    <div class="item-header item-menu-header" v-if="!selectedCount">
      <p></p>
    </div>

    <div
      class="item-selected-menu"
      style="display: block"
      v-show="selectedCount"
    >
      <a
        @click="handleShareData('shareinfo')"
        v-if="showOnSharefile && selectedCount === 1"
      >
        <i class="iconfont icon-file"></i>
        分享详情
      </a>
      <a
        @click="handleShareData('share_edit')"
        v-if="right__share_edit && showOnSharefile && selectedCount === 1"
      >
        <i class="ti-pencil-alt"></i>
        编辑分享
      </a>
      <a v-if="right__share_delete && showOnSharefile" @click="deleteShares">
        <i class="iconfont icon-trash"></i>
        取消分享
      </a>
    </div>
  </div>
</template>

<script>
import { shareInfo } from "@/api/share/share";
export default {
  name: "TableHeaderShare",
  components: {},
  props: {
    isList: Boolean,
  },
  data() {
    return {
      showA1: false,
    };
  },
  created() {
    // 初始化排序规则
    // this.$store.commit("sortById", 7);
  },
  computed: {
    right__share_delete () {
      return this.$store.getters.right__share_delete
    },
    right__share_edit () {
      return this.$store.getters.right__share_edit
    },
    headers() {
      return this.$store.state.drive.headers;
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    selectedCount() {
      return this.$store.state.drive.selectedDatas.length;
    },
    showOnSharefile: function () {
      return this.tab === "sharefile" || this.tab === "persona-sharefile";
    },
  },
  methods: {
    handleShareData(action) {
      shareInfo({
        share_number: this.selectedDatas[0].share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder", this.selectedDatas[0]);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    deleteShares() {
      this.$confirm({
        type: "confirm",
        content: `确定取消分享吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let share_list = this.selectedDatas.map(function (item) {
            return item.share_number;
          });
          this.$store
            .dispatch("deleteShares", {
              share_list: share_list,
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder");
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder");
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    sortByHeader(id) {
      this.$store.commit("sortById", id);
      this.$store.commit("sortByHeader");
    },
    toggleSelectAll() {
      this.$store.commit("toggleSelectAll");
    },
  },
  mounted() {
    if (this.$store.state.drive.drive === "persona") {
      return false;
    }
    let that = this;
    /*滚动停留*/
    let toplist_height = $("#toplist").offset().top; //获取div1的高度
    //滚动处理div
    $(window).scroll(function () {
      let this_scrollTop = $(this).scrollTop();
      if (this_scrollTop > toplist_height) {
        that.showA1 = true;
      }
      if (this_scrollTop < toplist_height) {
        that.showA1 = false;
      }
    });
  },
};
</script>

<style scoped>
.a1 .item-selected-menu {
  right: 20px;
}
.a1 {
  width: 1140px !important;
  position: fixed !important;
  top: 0;
  background: #f9f9f9;
  left: 50%;
  margin-left: -570px;
  height: 40px !important;
  z-index: 1000;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 10px;
}
</style>